"use client";

import { useQuery } from "@tanstack/react-query";
import { userApi, CurrentUser } from "@/lib/api/user";

export function useCurrentUser() {
  return useQuery<CurrentUser>({
    queryKey: ["currentUser"],
    queryFn: userApi.getMe,
    staleTime: 5 * 60 * 1000,
  });
}
